// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdUpdateArchivedStateResult = objectOf({
  info: string,
  undo_identifier: number,
  undo_data: objectOf({
    app_group_id: string,
    archive: boolean,
    landing_page_bson_ids: arrayOf(string),
  }),
});
